import { render, staticRenderFns } from "./ResizableAside.vue?vue&type=template&id=6d0a3e1a&scoped=true"
import script from "./ResizableAside.vue?vue&type=script&lang=js"
export * from "./ResizableAside.vue?vue&type=script&lang=js"
import style0 from "./ResizableAside.vue?vue&type=style&index=0&id=6d0a3e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a3e1a",
  null
  
)

export default component.exports